export enum DriverSuggestionType {
  OBSERVATION = 'OBSERVATION',
  INCIDENCE = 'INCIDENCE',
  OBJECT_FOUND = 'OBJECT_FOUND'
}